import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const SOURCE_LABELS = {
  direct: 'directe keuze',
  legacy: 'rol / bestaand recht',
  organization_role: 'organisatiebeheerder',
  preset: 'preset',
  team: 'team',
};

export const permissionSourceLabel = (state) => {
  if (!state) return 'niet geladen';
  if (state.source) return SOURCE_LABELS[state.source] || state.source;
  if (state.reason === 'default_deny') return 'geen toekenning';
  if (state.reason === 'module_not_entitled') return 'module niet beschikbaar';
  if (state.reason === 'inactive_membership') return 'inactief account';
  return state.reason || 'onbekend';
};

const PermissionStateControls = ({
  permissionOptions,
  states,
  disabled = false,
  savingPermission = null,
  onChange,
  footer = 'Erven gebruikt de bestaande rol/preset. Alleen “Weigeren” schrijft een expliciete deny.',
}) => (
  <div className="space-y-3">
    {permissionOptions.map(([permission, label]) => {
      const state = states?.[permission];
      const value = state?.explicit_effect || 'inherit';
      const isSaving = savingPermission === permission || savingPermission === true;

      return (
        <div key={permission} className="rounded-lg border border-slate-200 p-3">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div className="min-w-0">
              <p className="text-sm font-medium text-slate-800">{label}</p>
              <p className="mt-1 text-xs text-slate-500">
                {state
                  ? `Effectief: ${state.effective ? 'toegestaan' : 'geweigerd'} · via ${permissionSourceLabel(state)}`
                  : 'Effectieve waarde wordt door de server bepaald'}
              </p>
            </div>
            <Select
              value={value}
              disabled={disabled || isSaving}
              onValueChange={(effect) => onChange(permission, effect)}
            >
              <SelectTrigger className="w-full sm:w-32 sm:shrink-0">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="inherit">Erven</SelectItem>
                <SelectItem value="allow">Toestaan</SelectItem>
                <SelectItem value="deny">Weigeren</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
      );
    })}
    {footer && <p className="text-xs text-slate-500">{footer}</p>}
  </div>
);

export default PermissionStateControls;
